module.exports = __webpack_public_path__ + "img/ky.69021eb.svg";